import type { EventGuide } from './types';
import { chicagoGuide } from './chicago';

/** Races with a researched guide, keyed by race id. Everything else gets the generic planner. */
export const guides: Record<string, EventGuide> = {
  [chicagoGuide.raceId]: chicagoGuide,
};
